export const orderDetailsStrings = {
  english: {
    title: 'ORDER DETAILS',
    order: 'Order # ',
    placed: 'was placed on',
    currency: 'and is currently',
    product: 'Product',
    total: 'total',
    manage: 'You can manage your keys from My Account',
    pay: 'PAYMENT METHOD:',
    TOTAL: 'TOTAL:',
    info: 'BILLING INFORMATION',
  },

  japan: {
    title: '注文内容',
    order: 'Order #',
    placed: 'was placed on',
    currency: 'and is currently',
    product: '注文商品',
    total: '合計',
    pay: '決済方法:',
    TOTAL: '小計:',
    info: '請求先住所',
  },
};
